import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  const withInstantScrollBehavior = (callback) => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlBehavior = html.style.scrollBehavior;
    const prevBodyBehavior = body?.style.scrollBehavior ?? '';

    html.style.scrollBehavior = 'auto';
    if (body) {
      body.style.scrollBehavior = 'auto';
    }

    callback();

    requestAnimationFrame(() => {
      html.style.scrollBehavior = prevHtmlBehavior;
      if (body) {
        body.style.scrollBehavior = prevBodyBehavior;
      }
    });
  };

  const scrollToTopInstant = () => {
    withInstantScrollBehavior(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  };

  useLayoutEffect(() => {
    // Отключаем браузерное восстановление скролла (особенно заметно на reload)
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    let rafId = 0;
    let timeoutId = 0;

    // Если указан hash, пробуем прокрутить к элементу
    if (hash) {
      rafId = requestAnimationFrame(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          scrollToTopInstant();
        }
      });

      return () => {
        cancelAnimationFrame(rafId);
      };
    }

    // Иначе жёстко ставим начало страницы в несколько проходов,
    // чтобы убрать зависания скролла после переходов и reload.
    scrollToTopInstant();

    rafId = requestAnimationFrame(scrollToTopInstant);
    timeoutId = window.setTimeout(scrollToTopInstant, 60);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutId);
    };
  }, [pathname, hash]);

  useEffect(() => {
    // Жестко ставим верх при reload/back-forward cache
    const handlePageShow = (event) => {
      if (event.persisted) {
        scrollToTopInstant();
      }
    };

    const navEntry = performance.getEntriesByType('navigation')[0];
    if (navEntry && navEntry.type === 'reload') {
      requestAnimationFrame(scrollToTopInstant);
    }

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);

  useEffect(() => {
    // Показываем контент после загрузки CSS
    const root = document.getElementById('root');
    if (!root) return;

    const timeoutId = setTimeout(() => {
      root.classList.remove('content-hidden');
      root.classList.add('content-visible');
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  return null; // Этот компонент не рендерит ничего
}

export default ScrollToTop;
